var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueRocket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69112_69915)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04416 24.3691L9.37495 16.4553L25.6196 16.8722L32.5211 10.3159C38.7704 4.37976 47.122 1.1687 55.7387 1.38984L66.6481 1.66984L66.3681 12.5793C66.147 21.1959 62.5119 29.372 56.2626 35.3085L49.3612 41.8645L48.9443 58.1092L40.6135 66.0231L1.04416 24.3691ZM37.6467 23.2766C37.7331 19.9124 40.5304 17.2549 43.8948 17.3412C47.2592 17.4276 49.9166 20.225 49.8302 23.5893C49.7439 26.9537 46.9465 29.6111 43.5821 29.5247C40.2177 29.4384 37.5604 26.641 37.6467 23.2766Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62839 45.1937L20.2456 56.3702L4.06191 65.075L0.104977 60.9096L9.62839 45.1937Z",
    fill: "#5D5FEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69112_69915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "matrix(0.0256565 -0.999671 -0.999671 -0.0256565 64.9805 66.6484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRocket);
export default __webpack_public_path__ + "static/media/blueRocket.3f80ff61f3a77ee39ffebf4cefd9e0a8.svg";
export { ForwardRef as ReactComponent };